import { render, staticRenderFns } from "./Costing.vue?vue&type=template&id=dfa4f868&scoped=true&"
import script from "./Costing.vue?vue&type=script&lang=js&"
export * from "./Costing.vue?vue&type=script&lang=js&"
import style0 from "./Costing.vue?vue&type=style&index=0&id=dfa4f868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa4f868",
  null
  
)

export default component.exports